<template>
  <ClientModal @close-modal="$emit('close-modal', true)">
    <template #header>
      {{ $t('client.index.video_instructions') }}
    </template>
    <div
      class="videos"
      v-if="videos.length"
    >
      <div class="video__player">
        <div class="video__play">
          <AppVideoEmbed
            :code="videos[currentIndex].code"
            propHeight="300px"
          />
        </div>
        <div class="video__title">{{videos[currentIndex].name}}</div>
      </div>
      <div
        class="videos__pagination"
        v-if="videos.length>1"
      >
        <button
          @click="currentIndex = i"
          class="video__set_current_button"
          :class="{'active': i==currentIndex}"
          v-for="video,i in videos"
        >{{i+1}}</button>
      </div>

    </div>
    <div v-else>
      {{ $t('client.index.no_video_instructions') }}
    </div>

  </ClientModal>
</template>
<script>
export default {
  name: "VideoInstructionsModal",
  data() {
    return {
      currentIndex: 0,
    };
  },
  computed: {
    settings() {
      return this.$store.state.settings.settings;
    },
  },
  created() {
    this.$store.dispatch("clientVideoInstructions/fetch");
  },
  computed: {
    videos() {
      return this.$store.state.clientVideoInstructions.videos;
    },
  },
};
</script>
<style scoped>
.video__player {
  display: flex;
  flex-direction: column;
  row-gap: 20px;
}
.video__play {
  height: 300px;
}

.video__title {
  color: #1f2937;
  font-size: 18px;
  line-height: 1.1;
}
.videos__pagination {
  display: flex;
  column-gap: 10px;
  margin-top: 25px;
}
.video__set_current_button {
  width: 30px;
  height: 30px;
  display: grid;
  place-content: center;
  border: 1px solid #10b981;
  font-size: 24px;
  color: #172935;
  border-radius: 3px;
}
.video__set_current_button:hover {
  border-color: #172935;
}
.video__set_current_button.active {
  background-color: #10b981;
  color: #fff;
}
</style>
